import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './Login.module.css';
import { Button } from '../../components/common/Button/Button';
import { authAPI } from '../../services/api';
import { useToast } from '../../contexts/ToastContext';

const omgevingsCompasLogo = '/assets/logos/OmgevingsCompas_logo.svg';

export const ResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const toast = useToast();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('Wachtwoord te kort', 'Het wachtwoord moet minimaal 6 tekens bevatten.');
      return;
    }
    if (password !== confirm) {
      toast.error('Wachtwoorden komen niet overeen', 'Controleer het bevestigingswachtwoord.');
      return;
    }
    if (!token) return;
    setBusy(true);
    try {
      await authAPI.resetPassword(token, password);
      setDone(true);
      toast.success('Wachtwoord ingesteld', 'Je kunt nu inloggen met je nieuwe wachtwoord.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err: any) {
      toast.error('Resetten mislukt', err?.response?.data?.error || 'De link is ongeldig of verlopen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.loginScreen}>
      <div className={styles.loginLeft}>
        <div className={styles.loginBox}>
          <img src={omgevingsCompasLogo} alt="OmgevingsCompas" className={styles.loginLogo} />
          <p className={styles.loginSubtitle}>Stel een nieuw wachtwoord in voor je account</p>

          {done ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '0.95rem', color: '#323232', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                Je wachtwoord is ingesteld. Je wordt doorgestuurd naar de inlogpagina…
              </p>
              <button type="button" className={styles.forgotLink} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit' }} onClick={() => navigate('/login')}>
                Direct naar inloggen
              </button>
            </div>
          ) : (
            <form className={styles.loginForm} onSubmit={handleSubmit}>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Nieuw wachtwoord</label>
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={6}
                />
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Bevestig wachtwoord</label>
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder="••••••••"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  minLength={6}
                />
              </div>
              <Button type="submit" variant="primary" size="large" fullWidth disabled={busy}>
                {busy ? 'Opslaan…' : 'Wachtwoord instellen'}
              </Button>
              <p className={styles.contactText}>
                <button type="button" className={styles.forgotLink} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit' }} onClick={() => navigate('/login')}>
                  ← Terug naar inloggen
                </button>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
